"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateThemeMemberData = void 0;
const defaultTheme = {
    locale: "ar",
    direction: "rtl",
    isLTR: false,
    isRTL: true,
    isLoggedIn: false,
    isRegistered: false,
    isMobile: false,
    isDesktop: false,
    device: 'desktop',
    redirectUrl: "",
    url: "",
    country: 'jo',
};
const updateThemeMemberData = (data) => {
    defaultTheme.memberData = data;
};
exports.updateThemeMemberData = updateThemeMemberData;
exports.default = defaultTheme;
